// import Swiper styles
import 'swiper/css';
// import Swiper JS
import Swiper, { Navigation, Pagination } from 'swiper';

var titles = document.querySelectorAll('.js-swiper--timeline .swiper-slide');
var title = [];
titles.forEach(function(element) {
title.push(element.dataset.title);
});



const swiper = new Swiper('.js-swiper--timeline', {
  speed: 400,
  loop: true,

  modules: [Navigation, Pagination],
  // Pagination fraction numbers
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + title[index] + '</span>';
    },
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});

export default Swiper;